const url = '/monitor/userStat';

// 페이징 조회
export const getUserStatPage = async (conn, data) => {
  const { take, skip, userId, userTerm, rgnCode, dongCode, meainStatCode, bizType, dangerElderYn, isNotPlan } = data;
  const config = {
    params: {
      page: (take + skip) / take,
      size: take,
      userId: userId,
      userTerm: userTerm,
      rgnCode: rgnCode,
      dongCode: dongCode,
      meainStatCode: meainStatCode,
      bizType: bizType,
      dangerElderYn: dangerElderYn,
      notPlan: isNotPlan,
    },
  };
  const response = await conn.get(url + '/page', config);
  return response;
};

//전체 개소 상태의 수 (정상, 경고, 위험, 미작동, 설치예정)
export const getUserStatCnt = async (conn, data) => {
  const { userId, userTerm, rgnCode, dongCode } = data;
  const config = {
    params: {
      userId: userId,
      // userTerm: userTerm,
      rgnCode: rgnCode,
      dongCode: dongCode,
    },
  };
  const response = await conn.get(url + '/statCnt', config);

  return response;
};

// 위험대상자 수
export const getDangerYnCnt = async (conn, data) => {
  const { userId, userTerm, rgnCode, dongCode } = data;
  const config = {
    params: {
      userId: userId,
      rgnCode: rgnCode,
      dongCode: dongCode,
    },
  };
  const response = await conn.get(url + '/dangerCnt', config);
  
  return response;
};

//특이사항 수정
export const setUpdateUserNote = async (conn, data) => {
  const { userId, note } = data;
  const params = {
    userId: userId,
    note: note,
  };
  const response = conn.post(url + '/note', params);

  return response;
};

// 대상자 행동 패턴
export const getUserPattern = async (conn, data) => {
  const { userId, hour } = data;
  const config = {
    params: {
      userId: userId,
      hour: hour,
    },
  };
  const response = await conn.get(url + '/pattern', config);

  return response;
};

// 대상자 행동 패턴 추가 및 수정
export const setUserPattern = async (conn, data) => {
  const params = {
    userId: data.userId,
    hour: data.patternHour,
    pattern: data.patternContent,
  };
  const response = conn.post(url + '/pattern', params);

  return response;
};

// 대상자 목록 조회
export const getUsers = async (conn, data) => {

  const config = {
    params:{
      rgnCode: data.rgnCode,
      dongCode: data.dongCode,
    }
  }

  const response = await conn.get("user/area/list", config);

  return response;
}

// 위도 경도 구해오기
export const getCoordinates = async (conn, dataState) => {
  const config = {
    params: {
      userId: dataState.userId,
    }
  }

  const response = await conn.get(url + '/coordinates', config);

  return response;
}

// 위도 경도 구해오기 (시군구)
export const getRgnCoordinates = async (conn, dataState) => {
  const config = {
    params: {
      rgnCode: dataState.rgnCode,
    }
  }

  const response = await conn.get(url + '/coordinates/rgn', config);

  return response;
}

// 위도 경도 구해오기 (읍면동)
export const getDongCoordinates = async (conn, dataState) => {
  const config = {
    params: {
      dongCode: dataState.dongCode,
    }
  }

  const response = await conn.get(url + '/coordinates/dong', config);

  return response;
}